export default "__VITE_ASSET__CPRLlUJC__"